
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MossGrowthEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x + layerIndex) * spacing;
                const offY = this.pseudoRandom(y + layerIndex) * spacing;
                const clusters = Math.floor(5 * (config.parallaxComplexity || 1.0));
                
                const draw = () => {
                    for (let j = 0; j < clusters; j++) {
                        const cx = offX + (this.pseudoRandom(x + j) - 0.5) * spacing * 0.5;
                        const cy = offY + (this.pseudoRandom(y + j) - 0.5) * spacing * 0.5;
                        const r = (5 + this.pseudoRandom(x * y + j) * 15) * scale;
                        
                        ctx.beginPath();
                        ctx.arc(x + cx, y + cy, r, 0, Math.PI * 2);
                        ctx.fill();
                    }
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
